import React from 'react';
import ResponsibleBoDetailsContent from "./responsible-bo-details-content.jsx";
import ResponsibleTotalContent from "./responsible-total-content.jsx";
import NatureResponsibleContent from "./nature-responsible-content.jsx";
import NatureResponsibleTableContent from "./nature-responsible-table-content.jsx";

const ReportContent = ({data, collapsed, boName, tableMode}) => {
    return (
        <>
            <ResponsibleBoDetailsContent data={data} boName={boName}/>

            <ResponsibleTotalContent key={`total-${collapsed}`} data={data} boName={boName}/>

            { tableMode ? (
                <NatureResponsibleTableContent key={`nature-table-${collapsed}`} data={data} boName={boName}/>
            ) : (
                <NatureResponsibleContent key={`nature-${collapsed}`} data={data} boName={boName}/>
            )}

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;